/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VariableSettingUpdateDto } from './variableSettingUpdateDto';


export interface VariableSettingsRequest { 
    variables?: Array<VariableSettingUpdateDto>;
    gea_puid?: string;
}

